<template>
  <div class="wrapper">
    <div class="main main-raised-zero">
      <div class="section text-center" v-if="loading">
        <h2 class="title">Loading...</h2>
      </div>
      <div class="section text-center" v-if="filtered">
        <div class="container">
          <h2 class="title">Recipes</h2>
          <h5
            v-if="filtered.length !== recipes.length || RecipeListState.sorting.length > 0"
          ><span v-if="filtered.length !== recipes.length">Showing {{ filtered.length }} of {{ recipes.length }} </span>
          <span v-if="RecipeListState.sorting.length > 0">Sorted by {{ sortName }}</span></h5>
          <div class="team">
            <div class="md-layout">
              <recipe-list-item v-for="recipe in filtered" :key="recipe.id" :recipe="recipe"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RecipeService from "@/services/RecipeService.js";
import RecipeListItem from "@/views/RecipeListItem.vue";

export default {
  bodyClass: "recipe-page",
  components: { RecipeListItem },
  data() {
    return {
      loading: true,
      recipes: null,
      filtered: null,
      error: null
    };
  },
  computed: {
    sortName() {
      if (this.RecipeListState.sorting.length === 0) {
        return "";
      }

      switch (this.RecipeListState.sorting[0]) {
        case "timeMins":
          return "Time to Make";
        case "created":
          return "Date Added";
        case "rating":
          return "Rating";
        default:
          return "";
      }
    }
  },
  created() {
    this.fetchData();
  },
  watch: {
    RecipeListState: {
      handler(val) {
        this.filter();
      },
      deep: true
    }
  },
  methods: {
    fetchData() {
      this.error = null;
      this.recipes = null;
      this.loading = true;

      RecipeService.recipes()
        .then(recipes => {
          this.loading = false;
          this.recipes = recipes.sort((a, b) =>
            a.title === b.title ? 0 : a.title < b.title ? -1 : 1
          );
          this.filter();
        })
        .catch(error => {
          this.loading = false;
          this.error = error;
        });
    },
    filter() {
      const searchText = this.RecipeListState.searchText.toLowerCase();
      if (this.recipes) {
        this.filtered = this.recipes
          .filter(recipe => {
            return (
              Object.keys(recipe).some(
                key =>
                  typeof recipe[key] === "string" &&
                  recipe[key].toLowerCase().includes(searchText)
              ) ||
              (recipe.ingredients &&
                recipe.ingredients.some(ingredient =>
                  ingredient.name.toLowerCase().includes(searchText)
                ))
            );
          })
          .sort((a, b) => {
            if (this.RecipeListState.sorting.length > 0) {
              const sortKey = this.RecipeListState.sorting[0];
              return a[sortKey] === b[sortKey]
                ? 0
                : a[sortKey] < b[sortKey]
                ? 1
                : -1;
            } else {
              return 1;
            }
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}

.recipe-page {
  .page-header {
    &::before {
      background: rgba(0, 0, 0, 0.2);
    }
  }
}
</style>

